import { observable, action, computed, configure, runInAction } from "mobx";
import { createContext } from "react";
import { IJobPosition } from "../models/jobposition";
import { toast } from "react-toastify";
import agent from "../api/agent";

configure({ enforceActions: "always" });

class JobPositionStore {
  @observable jobpositionRegistry = new Map();
  @observable jobposition: IJobPosition | null = null;
  @observable certificateRegistry = new Map();
  @observable certificateSearchRegistry = new Map();
  @observable loadingInitial = false;
  @observable submitting = false;
  @observable target = "";

  @computed get jobpositionsByName() {
    return Array.from(this.jobpositionRegistry.values()).sort((a, b) =>
      a.name.localeCompare(b.name)
    );
  }

  @computed get certificatesByName() {
    return Array.from(this.certificateRegistry.values()).sort(
      (a, b) => a.name.localeCompare(b.name))
    ;
  }

  @computed get certificatesSearch() {
    return Array.from(this.certificateSearchRegistry.values()).sort(
      (a, b) => a.name.localeCompare(b.name))
    ;
  }

  @action loadJobPositions = async () => {
    // this.loadingInitial = true;
    try {
      const jobpositions = await agent.JobPositions.list();
      runInAction("loading jobpositions", () => {
        this.jobpositionRegistry.clear();
        jobpositions.forEach((jobposition) => {
          // jobposition.certificateId = jobposition.certificateId.split(',').map((cert: any) => 
          // ((this.certificateRegistry.has(Number(cert))) ? this.certificateRegistry.get(Number(cert)).name : ''));
          jobposition.certificateId = jobposition.certificateId.split(',').map((cert: any) => cert.trim())
          .filter((cert: any) => cert.length !== 0);
          this.jobpositionRegistry.set(jobposition.id, jobposition);
        });
        this.loadingInitial = false;
      });
    } catch (error) {
      runInAction("load JobPosition List Error", () => {
        this.loadingInitial = false;
      });
      toast.error("load JobPosition List Error");
    }
  };

  @action loadJobPosition = async (id: string) => {
    let position = this.getJobPosition(id);
    if (position) {
      this.jobposition = position;
      return position;
    } else {
      this.loadingInitial = true;
      try {
        position = await agent.JobPositions.details(id);
        runInAction("getting position", () => {
          position.certificateId = position.certificateId.split(',').map((cert: any) => cert.trim())
          .filter((cert: any) => cert.length !== 0);
          this.jobposition = position;
          this.loadingInitial = false;
        });
        return position;
      } catch (error) {
        runInAction("get position error", () => {
          this.loadingInitial = false;
        });
        toast.error("get position error");
        console.log(error);
      }
    }
  };

  getJobPosition = (id: string) => {
    return this.jobpositionRegistry.get(Number(id));
  };

  @action clearJobPosition = () => {
    this.jobposition = null;
  };

  @action createJobPosition = async (jobposition: IJobPosition, checked: string[]) => {
    this.submitting = true;
    jobposition.certificateId = checked.toString();
    try {
      await agent.JobPositions.create(jobposition);
      runInAction("create JobPosition", () => {
        this.submitting = false;
      });
    } catch (error) {
      runInAction("create JobPosition Error", () => {
        this.submitting = false;
      });
      toast.error("create JobPosition Error");
      console.log(error);
    }
  };

  @action editJobPosition = async (jobposition: IJobPosition) => {
    this.submitting = true;
    try {
      jobposition.certificateId = jobposition.certificateId.toString();
      await agent.JobPositions.update(jobposition);
      runInAction("editing jobposition", () => {
        jobposition.certificateId = jobposition.certificateId.split(',').map((cert: any) => cert.trim())
        .filter((cert: any) => cert.length !== 0);
        this.jobpositionRegistry.set(jobposition.id, jobposition);
        this.jobposition = jobposition;
        this.submitting = false;
      });
    } catch (error) {
      runInAction("edit jobposition error", () => {
        this.submitting = false;
      });
      toast.error("edit jobposition error");
      console.log(error);
    }
  };

  @action deleteJobPosition = async (id: string) => {
    this.submitting = true;
    this.target = id;
    try {
      await agent.JobPositions.delete(id);
      runInAction("deleting JobPosition", () => {
        this.jobpositionRegistry.delete(id);
        this.submitting = false;
        this.target = "";
      });
    } catch (error) {
      runInAction("edit jobposition error", () => {
        this.submitting = false;
        this.target = "";
      });
      toast.error("edit jobposition error");
      console.log(error);
    }
  };

  @action loadCertificates = async () => {
    this.loadingInitial = true;
    try {
      const certificates = await agent.Certificates.list();
      runInAction('loading certificates', () => {
        certificates.forEach(certificate => {
          this.certificateRegistry.set(certificate.id, certificate);
          this.certificateSearchRegistry.set(certificate.id, certificate);
        });
      })

    } catch (error) {
      runInAction('load Certificate List error' ,() => {
        this.loadingInitial = false;
      })
      toast.error('load Certificate List error');
    }
  };

  @action searchCertificate = async (term: string) => {
    let certificates = Array.from(this.certificateRegistry.values());
    if (term) {
      const selectedCertificates = certificates.filter((certificate) =>
        certificate.name.toLowerCase().includes(term.toLowerCase()) 
      );
      this.certificateSearchRegistry.clear();
        selectedCertificates.forEach((certificate) => {
          this.certificateSearchRegistry.set(certificate.id, certificate);
        });
    } else {
      this.certificateSearchRegistry.clear();
      certificates.forEach((certificate) => {
        this.certificateSearchRegistry.set(certificate.id, certificate);
      });
    }
  };

}

export default createContext(new JobPositionStore());
